export const getOrgReferenceCoordinates = (org?: {
  location?: { coordinates?: [number, number] } | null
}): { lat: number; lng: number } | undefined => {
  const coordinates = org?.location?.coordinates
  if (!coordinates) {
    return undefined
  }

  const [lng, lat] = coordinates
  return { lat, lng }
}
